import React from 'react';
import seoConfig from '../../seo.json';
import StudentReportComponent from 'src/components/university/StudentReport';
import Seo from 'src/components/Seo';

const StudentReport = () => {
	const seoInfo = seoConfig['profile'];

	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<div>
				<StudentReportComponent />
			</div>
		</>
	);
};

export default StudentReport;
